class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.closeTimeout);

    const activeMenu = HeaderMenu.activeMenu;
    const isSwitchingPanels = Boolean(activeMenu && activeMenu !== this);

    if (isSwitchingPanels) {
      activeMenu.disableTransition();
      activeMenu.close();
      this.disableTransition();
    }

    this.mainDetailsToggle.setAttribute('open', '');
    HeaderMenu.activeMenu = this;
    this.onToggle();

    if (isSwitchingPanels) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          activeMenu.enableTransition();
          this.enableTransition();
        });
      });
    }
  }

  onMouseLeave() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => this.close(), 300);
  }

  close() {
    super.close();
    if (HeaderMenu.activeMenu === this) HeaderMenu.activeMenu = null;
  }

  getContent() {
    return this.querySelector('.mega-menu__content');
  }

  disableTransition() {
    const content = this.getContent();
    if (content) content.classList.add('mega-menu__content--no-transition');
  }

  enableTransition() {
    const content = this.getContent();
    if (content) content.classList.remove('mega-menu__content--no-transition');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

HeaderMenu.activeMenu = null;

customElements.define('header-menu', HeaderMenu);
